import { tv } from '~/utils/tv'
export const TagLabelVariants = tv({
  base: `
    h-extrasmall font-semibold text-threepulse font-rdmodern
    leading-medium text-center whitespace-nowrap truncate
  `,
  variants: {
    // @TODO adicionar os tokens quando eles forem atualizados
    variants: {
      onSale: 'text-[var(--color-labeling-text-onSale-default)]',
      principal: 'text-[var(--color-labeling-text-principal-default)]',
      secondary: 'text-[var(--color-labeling-text-secondary-default)]',
      clubeRaia: 'text-[var(--color-labeling-text-clubeRaia-default)]',
      clubeDrogasil: 'text-[var(--color-labeling-text-clubeDrogasil-default)]',
      assinatura: 'text-[var(--color-labeling-text-assinatura-default)]',
      medicamentoGeladeira:
        'text-[var(--color-labeling-text-medicamentoGeladeira-default)]',
      receitaObrigatoria:
        'text-[var(--color-labeling-text-receitaObrigatoria-default)]',
      generico: 'text-[var(--color-labeling-text-generico-default)]',
      referencia: 'text-[var(--color-labeling-text-referencia-default)]',
      similar: 'text-[var(--color-labeling-text-similar-default)]',
    },
  },
})
